/* eslint-disable max-len */
import React, { useContext } from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';

import { RatingsIcon, RatingsWrapper } from '../../common-field-styles';
import { FormContext } from '../../../shared/contexts/form-context';
import { getNumbers, emptyOrNot } from '../../../../shared/utils';
import { setUserInputOnCtrl } from '../../../form/reducer/form';
import { ControlPropType } from '../../ctrl_proptype';

// Extract shape count from value
const getRating = (ctrl, inTable, tr, col) => {
  const value = inTable ? ctrl.value?.[tr - 1]?.[col - 1] : ctrl.value;
  return value ? parseInt(value.replace(/\D/g, ''), 10) : null;
};

export default function StarRatingSubComponent(props) {
  const dispatch = useDispatch();
  const { ctrl, inTable, col, tr } = props;
  const rating = getRating(ctrl, inTable, tr, col);
  const { inBuilder, inForm, currentPageNo } = useContext(FormContext);
  const columnType = inTable ? ctrl.props.column_types[col - 1] : ctrl.type;
  const starsCount = inTable ? ctrl.table_props[col - 1].stars_count : ctrl.props.stars_count;

  const saveUpdatedCtrl = (newValue) => {
    dispatch(
      setUserInputOnCtrl({
        newValue,
        isValid: true,
        property: 'value',
        page: currentPageNo - 1,
        ctrlId: ctrl.internal_id,
        ...(inTable && { tr: tr - 1, col: col - 1 }),
      })
    );
  };

  const handleShapeClick = (index) => {
    if (!inForm) return;
    const newRating = index + 1;
    const newRatingString = `${newRating} Star${newRating > 1 ? 's' : ''}`;
    saveUpdatedCtrl(rating !== newRating ? newRatingString : null);
  };

  return (
    <RatingsWrapper notInBuilder={!inBuilder} id={!inTable ? `fpl-${ctrl.internal_id}` : `fpl-${col}-${tr}`}>
      {getNumbers(starsCount).map((no, idx) => (
        <RatingsIcon
          tabIndex="0"
          key={`star-${no}`}
          onClick={() => handleShapeClick(idx)}
          className={`star big icon ${emptyOrNot(columnType, idx, rating)}`}
        />
      ))}
    </RatingsWrapper>
  );
}

StarRatingSubComponent.defaultProps = {
  tr: null,
  col: null,
  inTable: false,
};

StarRatingSubComponent.propTypes = {
  tr: PropTypes.number,
  col: PropTypes.number,
  inTable: PropTypes.bool.isRequired,
  ctrl: PropTypes.shape(ControlPropType).isRequired,
};
